import { render, staticRenderFns } from "./cover2.vue?vue&type=template&id=730583dd&scoped=true&"
import script from "./cover2.vue?vue&type=script&lang=js&"
export * from "./cover2.vue?vue&type=script&lang=js&"
import style0 from "./cover2.vue?vue&type=style&index=0&id=730583dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730583dd",
  null
  
)

export default component.exports